import React, { FC } from 'react';

import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from '@emotion/styled';

const StyledImage = styled(GatsbyImage)({
  maxWidth: '100%'
});

export const RemoteWorkImage: FC = () => {
  const data = useStaticQuery(
    graphql`
      query {
        file(relativePath: {eq: "homepage/cloud-insights.png"}) {
          childImageSharp {
            gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH)
          }
        }
      }
    `
  );
  return <StyledImage alt="" image={data.file.childImageSharp.gatsbyImageData} />;
};
